import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { scheduleState } from "atoms";
import { CartModel } from "atoms/models";
import { states } from "utils/const";
import Input from "components/Schedule/Input";

const ShippingAddressForm: React.FC<{ cart: CartModel }> = ({ cart }) => {
  const [schedule, setSchedule] = useRecoilState(scheduleState);

  useEffect(() => {
    setSchedule({
      ...schedule,
      shippingAddress: {
        ...schedule.shippingAddress,
        streetNumber: cart.serviceStreetNumber,
        streetName: cart.serviceStreetName,
        apartmentNumber: cart.serviceApartmentNumber,
        city: cart.serviceCity,
        state: cart.serviceState,
        zipCode: cart.serviceZipCode,
      },
      billCycle: cart.billCycle,
    });
    // eslint-disable-next-line
  }, [cart, setSchedule]);

  const handleShippingAddressInputChange = (name: string, value: string) => {
    setSchedule((prevState: any) => ({
      ...prevState,
      shippingAddress: {
        ...prevState.shippingAddress,
        [name]: value,
      },
    }));
  };

  return (
    <div className="shipping-address-form-container">
      <h3>Shipping Address</h3>
      <small className="fade">Address must be a physical address. We cannot ship to a PO box.</small>
      <div className="row">
        <div className="col-md-5 col-sm-12 mb-3">
          <Input
            id="streetNumber"
            name="streetNumber"
            label="Street Number"
            value={schedule.shippingAddress.streetNumber ? schedule.shippingAddress.streetNumber : ""}
            onChange={handleShippingAddressInputChange}
            inputMode="numeric"
          />
        </div>
        <div className="col-md-5 col-sm-12 mb-3">
          <Input
            id="streetName"
            name="streetName"
            label="Street Name"
            value={schedule.shippingAddress.streetName ? schedule.shippingAddress.streetName : ""}
            onChange={handleShippingAddressInputChange}
          />
        </div>
        <div className="col-md-2 col-sm-12 mb-3">
          <Input
            id="apartmentNumber"
            name="apartmentNumber"
            label="Apt. #"
            value={schedule.shippingAddress.apartmentNumber ? schedule.shippingAddress.apartmentNumber : ""}
            onChange={handleShippingAddressInputChange}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 col-sm-12 mb-3">
          <Input
            id="city"
            name="city"
            label="City"
            value={schedule.shippingAddress.city ? schedule.shippingAddress.city : ""}
            onChange={handleShippingAddressInputChange}
          />
        </div>
        <div className="col-md-4 col-sm-12 mb-3">
          <div className="form-floating">
            <select
              className="form-select is-valid"
              id="state"
              value={schedule.shippingAddress.state ? schedule.shippingAddress.state : ""}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleShippingAddressInputChange("state", e.target.value)}
            >
              {states.map((state: any, index: number) => {
                return (
                  <option key={index} value={state.abbreviation}>
                    {state.name}
                  </option>
                );
              })}
            </select>
            <label htmlFor="floatingSelect">State</label>
          </div>
        </div>
        <div className="col-md-4 col-sm-12 mb-3">
          <Input
            id="zipCode"
            name="zipCode"
            label="Zip Code"
            value={schedule.shippingAddress.zipCode ? schedule.shippingAddress.zipCode : ""}
            onChange={handleShippingAddressInputChange}
            inputMode="numeric"
          />
        </div>
      </div>
    </div>
  );
};

export default ShippingAddressForm;
